import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=97786788&scoped=true&"
var script = {}
import style0 from "./Signup.vue?vue&type=style&index=0&id=97786788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97786788",
  null
  
)

export default component.exports